import WarningIcon from '@mui/icons-material/Warning';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LANG_TEXT } from '../../constants/language';

interface UnsavedChangesBannerProps {
    onSave: () => void;
    onCancel: () => void;
    isSaving?: boolean;
    disabled?: boolean;
}

export function UnsavedChangesBanner({ onSave, onCancel, isSaving = false, disabled = false }: UnsavedChangesBannerProps) {
    const { t } = useTranslation();
    return (
        <Box
            sx={{
                position: 'sticky',
                bottom: 0,
                left: 0,
                right: 0,
                bgcolor: '#fff',
                borderTop: '1px solid #e0e0e0',
                p: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                zIndex: 1000,
                boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <WarningIcon sx={{ color: '#ff9800' }} />
                <Typography sx={{ color: '#ff9800', fontWeight: 500 }}>
                    {t(LANG_TEXT.YOU_HAVE_UNSAVED_CHANGES)}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 1 }}>
                <Button
                    variant="outlined"
                    onClick={onCancel}
                    disabled={isSaving}
                    sx={{
                        textTransform: 'none',
                        borderColor: '#757575',
                        color: '#757575',
                        '&:hover': {
                            borderColor: '#424242',
                            bgcolor: '#f5f5f5',
                        },
                    }}
                >
                    {t(LANG_TEXT.CANCEL)}
                </Button>
                <Button
                    variant="contained"
                    onClick={onSave}
                    disabled={isSaving || disabled}
                    sx={{
                        bgcolor: '#2196f3',
                        textTransform: 'none',
                        '&:hover': {
                            bgcolor: '#1976d2',
                        },
                        '&:disabled': {
                            bgcolor: '#90caf9',
                        },
                    }}
                >
                    {isSaving ? t(LANG_TEXT.SAVING) : t(LANG_TEXT.SAVE)}
                </Button>
            </Box>
        </Box>
    );
}
